import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=d2e4e20c&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"
import style0 from "./resume.vue?vue&type=style&index=0&id=d2e4e20c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4e20c",
  null
  
)

export default component.exports